<script>
  import plants from "../Plants/plants-store.js";

  import CalendarItem from "./CalendarItem.svelte";
  import PlantFilter from "../Plants/plantFilter.svelte";
  export let locationText;

  let favsOnly = false;
  export let data;
  export let locationSet;

  function setFilter(event) {
    favsOnly = event.detail === 1;
  }

  $: filteredPlants = favsOnly ? $plants.filter((p) => p.isFavorite) : $plants;
</script>

<style>
  .location-details {
    display:flex;
    justify-content: center;
    padding-left: var(--space-4x);
  }
</style>

<section class="plan-controls">
    <PlantFilter {locationText} {locationSet} on:select={setFilter} on:plangarden />
</section>

<section class="calendar">
  {#if data != null}
  <div class='location-details'>
    <div><p>Explore the planting schedule for {locationText} below. Click on the timeline to find the resources you will need throughout the year.</p></div>
  </div>
    {#each filteredPlants as plant}
      <CalendarItem 
        {plant}
        data = {[...data.filter((d) => d.plantName === plant.commonName)]}
        on:toggleseeds 
        on:togglegrow 
        on:toggleharvest/>
    {/each}
  {/if}
</section>
